<template>
  <div>
    <analysis-header 
      :totalAmount="totalAmount" 
      ref="analysisHeader" 
      title="Paylaşım/Satış Analizi" 
      :subTitle="countTitle"
      @update-range="updateRange"
      v-if="!this.infId && !this.groupId"
    ></analysis-header>

    <b-card-title class="text-danger mt-2" v-if="loadChart && dataList.length === 0">
      Seçilen tarihler arasında kayıt bulunamadı
    </b-card-title>

    <b-row class="match-height" v-show="dataList.length > 0">
      <!-- Sipariş Tutarları Grafiği -->
      <b-col md="12">
        <chartjs-horizontal-bar-chart 
          @select-row="selectRow" 
          :chartData="chartDataHorizontal" 
          :loadChart="loadChart" 
          :totalAmount="totalAmount"

        />
        
        <b-modal 
        :visible="detailPopup"
         v-if="detailPopup"
         size="lg"
         ok-only
         ok-title="Kapat"
         @shown="onModalShown"
         @change="detailPopup=!detailPopup, loadApex=false" >
         
          <b-card>
            <b-card-title class="mb-1 d-flex justify-content-between w-100">
              <div v-if="apexData.detail.influencer.id">
                <influencer-link-btn :id="apexData.detail.influencer.id" :name="apexData.detail.influencer.username" class="mr-5px"/> -
                {{ apexData.detail.campaign_name }}
              </div>
              <div>
                {{ apexData.detail.total_count }} Adet / {{ priceFormat(apexData.detail.total_amount) }}
              </div>
            </b-card-title>
            <b-card-sub-title class="mb-2">
              <b class="text-primary"> {{ formatDate(getRangeDate[0]) }} - {{ formatDate(getRangeDate[1]) }}</b> Sipariş Detayları
            </b-card-sub-title>
            <apex-donut-chart :test="detailPopup" v-if="loadApex" :chartData="apexData" />
          </b-card>
        </b-modal>
        <!-- Row Detail End -->
      </b-col>
    </b-row>

    <b-card title="Satışı bulunmayan Paylaşımlar" class="mt-2" v-if="zeroData.length>0">
        <b-table-lite
          ref="refUserListTable"
          :items="zeroData"
          responsive
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(campaign_name)="data">
            <campaign-link-btn :name="data.item.campaign_name.replace(data.item.influencer.username+'-','')":group="true" :route="getLinkName(data.item)" />
          </template>

          <template #cell(influencer)="data">
            <!-- Paylaşım Link -->
            <span v-if="data.item.influencer && data.item.influencer.id && data.item.type==0" >
              <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username"/>
            </span>
          </template>
        </b-table-lite>
      </b-card>

  </div>
</template>

<script>
import ChartjsHorizontalBarChart from './ChartjsHorizontalInfluencer.vue';
import AnalysisHeader from './AnalysisHeader.vue';
import { BRow, BCol, BCard, BCardHeader, BButton, BCardSubTitle, BCardTitle, BModal, BTableLite } from 'bootstrap-vue';
import vSelect from 'vue-select';
import ApexDonutChart from '@core/components/charts/apex/ApexDonutChart.vue';
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue';
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue';

export default {
  props: {
    infId: {
      type: Number,
      default: null,
    },
    groupId: {
      type: Number,
      default: null,
      required:false
    },
    dateRange: {
      type: Array,
      default: () => null,
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BCardHeader,
    BCardSubTitle,
    BCardTitle,
    ChartjsHorizontalBarChart,
    AnalysisHeader,
    ApexDonutChart,
    InfluencerLinkBtn,
    vSelect,
    BModal,
    BTableLite,
    CampaignLinkBtn
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: '#ffe730',
            borderColor: 'transparent',
            barThickness: 15,
          },
        ],
      },
      zeroData: [],
      chartDataHorizontal: {},
      apexData: {
        labels: ['Teslim Edildi', 'İptal Edildi', 'Ödeme Bekleniyor', 'Onaylandı','Ürün Hazırlanıyor','Kapıda Ödeme Teyit Bekleniyor'],
      },
      detailPopup: false,
      loadChart: false,
      loadApex:false,
      dataList: [],
    };
  },
  created() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const defaultDate = this.dateRange || [this.changeFormat(firstDayOfMonth), this.changeFormat(today)];
    this.getData(defaultDate[0], defaultDate[1], this.infId, this.groupId);
  },
  methods: {
    getLinkName(item) {
      let route = {
        name: '',
        params: {
          id: item.id
        }
      };

      if (item.type == 0) {
        if (item.links && item.links.length > 0) {
          route.name = "campaign-group-detail";
          route.params.id = item.group_id;
        } else {
          route.name = "campaign-detail";
        }
      } else if (item.type == 1) {
        route.name = "story-detail";
      } else if (item.type == 2) {
        route.name = "sms-detail";
      } else if (item.type == 4) {
        route.name = "whatsapp-detail";
      } else if (item.type == 3) {
        route.name = "bio-detail";
        route.params.platform_id = item.platform.id;
      }

      return route;
    },
    updateRange(range) {
      this.getData(range[0], range[1], this.infId, this.groupId);
    },
    onModalShown() {
      // Grafik gibi içerikler sadece görünüm tamamlandığında yüklensin
      this.loadApex = true;
    },
    getData(startDate = null, endDate = null, infId = null, groupId = null) {
      const params = { start_date: startDate, end_date: endDate };
      if (infId) params.infId = infId;
      if (groupId) params.groupId = groupId;
      if (infId) params.ordersControl = true;
      this.$http
        .get('/analysis/links', { params })
        .then((response) => {          
          const data = response.data.data.hasOrder;

          this.zeroData = response.data.data.noOrder;

          this.dataList = data.sort((a, b) => b.total_amount - a.total_amount);
          this.updateChartData();
        })
        .catch((error) => {
          console.error('Veri alımı sırasında bir hata oluştu:', error);
        });
    },
    selectRow(data) {
      this.detailPopup = true; // Popup'u göster
      
      // Seçilen fenomeni al
      const selectedData = this.dataList[data];

      // Status sayımlarını başlat
      const counts = { delivered: 0, cancelled: 0, pending: 0, approved: 0,ready_product:0, waitingPay:0 };

      // Siparişleri statuslere göre analiz et
      if (selectedData.orders && selectedData.orders.length > 0) {
        selectedData.orders.forEach((order) => {
          switch (order.order_status_id) {
            case 8:
              counts.delivered++;
              break; // Teslim Edildi
            case 9:
              counts.cancelled++;
              break; // İptal Edildi
            case 2:
              counts.pending++;
              break; // Ödeme Bekleniyor
            case 3:
              counts.ready_product++;
              break; // Ürün Hazırlanıyor
            case 12:
              counts.approved++;
              break; // Onaylandı
            case 4:
              counts.waitingPay++;
              break; // Kapıda ödeme bekleniyor
            default:
              break;
          }
        });
      }


      // Toplam sipariş sayısını hesapla
      const totalOrders =
        counts.delivered + counts.cancelled + counts.pending + counts.approved + counts.ready_product + counts.waitingPay;

      // Oranları hesapla
      const percentages = totalOrders
        ? {
            delivered: (counts.delivered / totalOrders) * 100,
            cancelled: (counts.cancelled / totalOrders) * 100,
            pending: (counts.pending / totalOrders) * 100,
            approved: (counts.approved / totalOrders) * 100,
            ready_product: (counts.ready_product / totalOrders) * 100,
            waitingPay: (counts.waitingPay / totalOrders) * 100,
          }
        : { delivered: 0, cancelled: 0, pending: 0, approved: 0 };

      // `apexData`'yı güncelle
      this.apexData = {
        ...this.apexData, // Mevcut `apexData` içeriğini kopyala
        detail: { ...selectedData }, // Detay bilgisini ekle
        series: [
          parseFloat(percentages.delivered.toFixed(2)), // Float değer olarak ekle
          parseFloat(percentages.cancelled.toFixed(2)),
          parseFloat(percentages.pending.toFixed(2)),
          parseFloat(percentages.approved.toFixed(2)),
          parseFloat(percentages.ready_product.toFixed(2)),
          parseFloat(percentages.waitingPay.toFixed(2)),
        ],
        counts: [
          counts.delivered,
          counts.cancelled,
          counts.pending,
          counts.approved,
          counts.ready_product,
          counts.waitingPay,
        ], // Adetleri ayrı bir dizi olarak sakla
      };
    },
    updateChartData() {
      this.loadChart = false;

      const labels = this.dataList.map((item) => {
      if (this.groupId) {
        return `${item.influencer?.username ?? 'Bilinmeyen'}`;
      }
      return item.campaign_name;
    });
      const dataAmount = this.dataList.map((item) => [item.total_count, item.total_amount]);

      this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
      this.chartDataHorizontal.labels = [...labels];
      this.chartDataHorizontal.datasets[0].data = [...dataAmount];

      setTimeout(() => {
        this.loadChart = true;
      }, 500);
    },
  },
  computed: {
    totalAmount() {
      return this.dataList.reduce((total, item) => total + item.total_amount, 0);
    },
    getRangeDate() {
      return this.$refs.analysisHeader.rangeDate;
    },
    countTitle(){
      let link = this.dataList.length
      let order = this.dataList.reduce((total, item) => total + item.total_count, 0);
      return "<b>"+link+"</b> Paylaşım / <b>"+order+"</b> sipariş"
    }
  },
};
</script>

<style>
.row-detail-popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
